<p *ngIf="is_loading">Loading ...</p>
<div class="card mb-3" *ngIf="!is_loading">
    <div class="card-header">            
        <h2 class="card-title mb-0">Player Information</h2>
    </div>
    <div class="card-body">
        <table class="table table-striped table-sm mb-0">
            <tbody>
                <tr><th>Name</th><td>{{data.name}}</td></tr>
                <tr><th>Code</th><td>{{data.code}}</td></tr>
                <tr><th>Mobile</th><td>
                    {{data.mobile}} <em>*</em><br/>
                    <ng-container *ngFor="let m of data.mobiles; let i =index">
                        {{m.mobile}}<br/>
                    </ng-container>
                    </td></tr>
                <tr><th>DOB</th><td>{{data.dob}}</td></tr>
                <tr><th colspan="2">Bank</th></tr>
                <tr *ngFor="let bank of data.banks"><td colspan="2">{{bank.bank}} - {{bank.account}}</td></tr>
                <tr><th>Status</th><td>{{data.status ? 'Active' : 'Disabled'}}</td></tr>
                <tr><th>Can Login</th><td>{{data.can_login ? 'Yes' : 'No'}}</td></tr>
                <tr><th colspan="2" class="bg-dark text-dark">Summary</th></tr>
                <tr><th>Wallet Balance</th><td class="d-flex flex-row justify-content-between"><span>{{setting.currency}}</span><span>{{(data.wallet ? data.wallet : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Topup</th><td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.topup ? summary.topup : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Withdraw</th><td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.withdraw ? summary.withdraw : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Profit</th><td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.profit ? summary.profit : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Tips</th><td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.tips ? summary.tips : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Bonus</th><td class="d-flex flex-row justify-content-between"><span>RM</span><span>{{(summary.bonus ? summary.bonus : 0) | number: '1.2-2'}}</span></td></tr>
                <tr><th>Total Point</th><td class="d-flex flex-row justify-content-between"><span class="ms-auto">{{(summary.point ? summary.point : 0) | number: '1.2-2'}}</span></td></tr>
            </tbody>
        </table>
    </div>
</div>